import React, { useState } from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import { setLanguage, useLang } from "../../../_metronic/i18n";
import { makeStyles } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./languageSelectorDropdown.scss"
import az from "./../../../_metronic/_assets/flags/azerbaijan.svg";
import uk from "./../../../_metronic/_assets/flags/uk.svg";
import { useIntl } from "react-intl";

const languages = [
  {
    lang: "az",
    name: "az",
    flag: az,
  },
  {
    lang: "en",
    name: "en",
    flag: uk,
  }
];

export function LanguageSelectorDropdown() {

  const lang = useLang();
  const currentLanguage = languages.find((x) => x.lang === lang);


  const currentLang = useLang();
  const [isOpen, setIsOpen] = useState(false);

  const intl=useIntl();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLanguageChange = (language) => {
    setLanguage(language);
    setIsOpen(false);
  };

  const handleBlur = (event) => {
    // Only close dropdown if the blur happens outside of the dropdown button or the dropdown itself
    if (!event.relatedTarget || !event.relatedTarget.closest(".language-selector")) {
      setIsOpen(false);
    }
  };

  return (
    <div className="language-selector" tabIndex="0" onBlur={handleBlur}>
      {/* <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip id="language-tooltip">{intl.formatMessage({ id: "selected_language"})} : {currentLanguage.name.replace(/^./, c => c.toUpperCase())}</Tooltip>}
      > */}
        <div className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1" onClick={toggleDropdown}>
          {/* <img
            className="h-25px w-25px rounded"
            src={languages.find((lang) => lang.lang === currentLang).flag}
            alt={currentLang}
          /> */}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <circle cx="12.4287" cy="12.769" r="9" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.02881 9.76904H20.8288" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.02881 15.769H20.8288" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9289 3.76904C8.49181 9.27682 8.49181 16.2613 11.9289 21.769" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.9287 3.76904C16.3658 9.27682 16.3658 16.2613 12.9287 21.769" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      {/* </OverlayTrigger> */}

      {isOpen && (
        <div className="dropdown-menu navbar-menu-language "  >
          <ul
            className="lang-menu"
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              textAlign: "center"
            }}
          >
            {languages.map((language) => (
              <li
                key={language.lang}
                className={clsx("navi-item", {
                  active: language.lang === currentLang
                })}
                onClick={() => handleLanguageChange(language.lang)}
                style={{ fontSize: "17px", paddingBottom: "2px" }}
              >
                <span className="navi-text">{language.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
    // <Dropdown>
    //   <Dropdown.Toggle
    //     id="dropdown-toggle-my-cart"
    //   >
    //     <OverlayTrigger
    //       placement="bottom"
    //       overlay={
    //         <div></div>
    //       }
    //     >
    //       <div className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
    //         <img
    //           className="h-25px w-25px rounded"
    //           src={currentLanguage.flag}
    //           alt={currentLanguage.name}
    //         />
    //       </div>
    //     </OverlayTrigger>
    //   </Dropdown.Toggle>

    //   <Dropdown.Menu style={{ minWidth: "100%" }}>
    //     <ul
    //       className="lang-menu"
    //       style={{
    //         listStyle: "none",
    //         padding: 0,
    //         margin: 0,
    //         textAlign: "center",
    //       }}
    //     >
    //       {languages.map((language) => (
    //         <li
    //           key={language.lang}
    //           className={clsx("navi-item", {
    //             active: language.lang === currentLanguage.lang,
    //           })}
    //           onClick={() => setLanguage(language.lang)}
    //           style={{ fontSize: "17px", paddingBottom: "2px" }}
    //         >
    //           <a href="#" className="navi-link">
    //             <span className="navi-text">{language.name}</span>
    //           </a>
    //         </li>
    //       ))}
    //     </ul>
    //   </Dropdown.Menu>
    // </Dropdown>
  );
}